import React from 'react';

const OtherThird = ({ data, onClick }) => {
  return (
    <div onClick={onClick} className='mb-8 text-xxs sm:text-xs md:text-sm lg:text-lg xl:text-xl'>
      <div className='flex flex-row w-full border border-black'>
        <div className='flex flex-col w-[11%] border border-black'>
          <div className='bg-blue-200 h-full flex justify-center items-center text-center'>가동현황</div>
        </div>
        <div className='flex-grow border border-black'>
          <div className='flex flex-row border-b-2 border-black'>
            <div className='w-[12.5%] h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center '>
              호기
            </div>
            <div className='w-[12.5%] h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-l-2 border-black'>
              지종
            </div>
            <div className='w-[12.5%] h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-l-2 border-black'>
              분
            </div>
            <div className='w-[12.5%] h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-l-2 border-black'>
              시간
            </div>
            <div className='w-[12.5%] h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-l-2 border-black'>
              구분
            </div>
            <div className='w-[37.5%] h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-l-2 border-black'>
              사유
            </div>
          </div>
          <div className='flex flex-row border-b-2 border-black'>
            <div className='w-[12.5%] h-[60px] sm:h-[90px] md:h-[120px] flex justify-center items-center text-center '>
              PM2
            </div>
            <div className='w-[12.5%] h-[60px] sm:h-[90px] md:h-[120px] flex text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '>
                  소계
                </div>
              </div>
            </div>
            <div className='w-[12.5%] h-[60px] sm:h-[90px] md:h-[120px] flex justify-center items-center text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>
            <div className='w-[12.5%] h-[60px] sm:h-[90px] md:h-[120px] flex justify-center items-center text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>
            <div className='w-[12.5%] h-[60px] sm:h-[90px] md:h-[120px] flex justify-center items-center text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>
            <div className='w-[37.5%] h-[60px] sm:h-[90px] md:h-[120px] flex justify-center items-center text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>
          </div>
          <div className='flex flex-row border-b-2 border-black'>
            <div className='w-[12.5%] h-[60px] sm:h-[90px] md:h-[120px] flex justify-center items-center text-center '>
              PM3
            </div>
            <div className='w-[12.5%] h-[60px] sm:h-[90px] md:h-[120px] flex text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '>
                  소계
                </div>
              </div>
            </div>
            <div className='w-[12.5%] h-[60px] sm:h-[90px] md:h-[120px] flex justify-center items-center text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>
            <div className='w-[12.5%] h-[60px] sm:h-[90px] md:h-[120px] flex justify-center items-center text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>
            <div className='w-[12.5%] h-[60px] sm:h-[90px] md:h-[120px] flex justify-center items-center text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>
            <div className='w-[37.5%] h-[60px] sm:h-[90px] md:h-[120px] flex justify-center items-center text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>
          </div>
          {/* 합계 부분 */}
          <div className='flex flex-row'>
            <div className='w-[25%] h-[20px] sm:h-[30px] md:h-[40px] flex text-center'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '>
                  합계
                </div>
              </div>
            </div>

            <div className='w-[12.5%] h-[20px] sm:h-[30px] md:h-[40px] flex text-center'>
              <div className='flex flex-col flex-grow border-l-2 border-black'>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>

            <div className='w-[12.5%] h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>
            <div className='w-[12.5%] h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>
            <div className='w-[37.5%] h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-l-2 border-black'>
              <div className='flex flex-col flex-grow '>
                <div className='h-[40px] flex justify-center items-center text-center '></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherThird;
